import React, {useState} from 'react'
import {connect} from 'react-redux'
import {Button, Checkbox, message} from 'antd'
import {setField, modified} from './action_creators'
import save from './save/save'
import archiveForm from './save/archiveForm'

const stp = (state) => ({published: state.form.active, formId: state.form.id})
const dtp = (dispatch) => ({
  setField: (value) => dispatch(setField('form_field')(`active`, value)),
  modified: (value) => dispatch(modified(value)),
})

export function Header({setField, published, formId, modified}) {
  const [archiveChecked, setArchiveChecked] = useState(false)

  async function togglePublish() {
    if (!published && archiveChecked) {
      message.loading('Archiving current version...', 0)
      try {
        await archiveForm(formId)
        message.destroy()
        message.success('Version archived')
      } catch (e) {
        message.destroy()
        message.error('Failed to archive version')
        console.error(e)
        return
      }
    }
    setField(!published)
    save()
    modified(false)
  }


  return (
    <div className="flex-row">
      <h1 className="page-title pageTitle" style={{flex: 1}}>
        Form Builder
      </h1>
      <div className="flex-row" style={{alignItems: 'center'}}>
        {!published && (
          <div className="margin-right-0-5">
            <Checkbox
              checked={archiveChecked}
              onChange={(e) => setArchiveChecked(e.target.checked)}
            >
              Archive current version
            </Checkbox>
          </div>
        )}
        <div className="margin-right-0-5">
          <Button
            ghost={false}
            className="thick"
            type={published ? `default` : `primary`}
            size="large"
            onClick={togglePublish}
          >
            {published ? `Unpublish` : `Save and Publish`}
          </Button>
        </div>
      </div>
    </div>
  )
}

const ConnectedHeader = connect(stp, dtp)(Header)
export default ConnectedHeader
